import React from "react";

const AppVersion = () => {
  return (
    // <span className="fixed bottom-0 left-0 text-black text-base text-right">
    <span className="absolute bottom-4 left-4 text-white">
      {process.env.REACT_APP_VERSION ? process.env.REACT_APP_VERSION : ""}
    </span>
  );
};

export default AppVersion;
